import React from "react";
import SEO from "@/components/SEO";
import { SEO_KEYWORDS } from "@/seo/seoData";
import { Layout } from "@/components/layout/Layout";
import { HeroSection } from "@/components/home/HeroSection";
import { AboutSection } from "@/components/home/AboutSection";
import { ServicesSection } from "@/components/home/ServicesSection";
import { ProcessSection } from "@/components/home/ProcessSection";
import { ProjectsSection } from "@/components/home/ProjectsSection";
import { TrustSection } from "@/components/home/TrustSection";
import { TestimonialsSection } from "@/components/home/TestimonialsSection";
import { FAQSection } from "@/components/home/FAQSection";
// import { WhyChooseUsSection } from '@/components/home/WhyChooseUsSection';

// import { ValuePropositionSection } from '@/components/home/ValuePropositionSection';
// import { ContactSection } from '@/components/home/ContactSection';
// import { BlogPreviewSection } from '@/components/home/BlogPreviewSection';
import { CTASection } from "@/components/home/CTASection";

export default function HomePage() {
  return (
    <Layout>
      {/* SEO Meta */}
   <SEO
  title="Best Digital Agency in Vancouver | Square Trigger"
  description="Boost your Business with Square Trigger, the best Digital agency in Vancouver, specializing in Website development and Search Engine Optimization and more."
  keywords={SEO_KEYWORDS.home}
  ogTitle="Best Digital Agency in Vancouver | Square Trigger"
  ogDescription="Boost your Business with Square Trigger, the best Digital agency in Vancouver, specializing in Website development and Search Engine Optimization and more."
  ogSiteName="Square Trigger Home page"
  ogImage="https://images.unsplash.com/photo-1519389950473-47ba0277781c"
/>

      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <ProcessSection />
      <ProjectsSection />
      <TrustSection />
      <TestimonialsSection />
      <FAQSection />
      {/*<WhyChooseUsSection />*/}

      {/* <ValuePropositionSection /> */}
      {/* <ContactSection /> */}
      {/*<BlogPreviewSection />*/}
      <CTASection />
    </Layout>
  );
}